import { graphql } from 'react-relay';
export const ContentPropertiesQuery = graphql`
	query ContentPropertiesQuery($contentId: ID, $versionOverride: Int) {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				id
				type
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
export const ContentPropertiesQueryWithBodyRepresentation = graphql`
	query ContentPropertiesQueryWithBodyRepresentationQuery($contentId: ID, $versionOverride: Int) {
		content(id: $contentId, version: $versionOverride) {
			nodes {
				id
				type
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				operations {
					operation
					targetType
				}
				body {
					dynamic {
						representation
					}
				}
				metadata {
					frontend {
						fabricEditorSupported
					}
				}
			}
		}
	}
`;
